import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { AppReviewCommentItem } from '@shared/components/appReviewCommentItem';
import { mergeStyleSets, Spinner, SpinnerSize, Stack } from '@fluentui/react';
import { Constants } from '@shared/utils/constants';
import { NeutralColors } from '@fluentui/theme';
import { AppReviewItemCommentPagination } from '@shared/components/appReviewCommentCollection/appReviewItemCommentPagination';
import { AppReviewItemCommentEmptyMessage } from '@shared/components/appReviewCommentCollection/appReviewItemCommentEmptyMessage';
const contentStyles = mergeStyleSets({
    commentsContainer: {
        marginBottom: '20px'
    },
    paginationContainer: {
        marginTop: '10px'
    },
    emptyMessage: {
        margin: '15px 0',
        color: NeutralColors.gray130
    },
    loader: {
        margin: '25px 0'
    }
});
export function AppReviewItemCommentCollectionListSection({ comments, currentPage, locale, totalPageCount, onSeeMoreClick, onSeeLessClick, onCommentDelete, onCommentEdit }) {
    const mapCommentsToComponents = ({ reducedCommentIds, commentsById })=>{
        return reducedCommentIds.slice(0, currentPage * Constants.Reviews.CommentsPerPage).map((commentId)=>/*#__PURE__*/ _jsx(AppReviewCommentItem, {
                onEdit: (updatedContent)=>{
                    onCommentEdit(commentId, updatedContent, false);
                },
                onDelete: ()=>{
                    onCommentDelete(commentId, false);
                },
                locale: locale,
                comment: commentsById[`${commentId}`]
            }, commentId));
    };
    const mapNewlyAddedCommentsToComponents = (comments)=>{
        return comments.map((comment)=>/*#__PURE__*/ _jsx(AppReviewCommentItem, {
                onEdit: (updatedContent)=>onCommentEdit(comment.id, updatedContent, true),
                onDelete: ()=>onCommentDelete(comment.id, true),
                locale: locale,
                comment: comment
            }, comment.id));
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: contentStyles.commentsContainer,
        children: [
            (comments === null || comments === void 0 ? void 0 : comments.reducedCommentIds.length) ? [
                ...mapCommentsToComponents(comments),
                /*#__PURE__*/ _jsx(AppReviewItemCommentPagination, {
                    currentPage: currentPage,
                    totalPageCount: totalPageCount,
                    onSeeMoreClick: ()=>onSeeMoreClick(),
                    onSeeLessClick: ()=>onSeeLessClick()
                }, "pagination")
            ] : !(comments === null || comments === void 0 ? void 0 : comments.isLoading) && /*#__PURE__*/ _jsx(AppReviewItemCommentEmptyMessage, {}),
            (comments === null || comments === void 0 ? void 0 : comments.isLoading) && /*#__PURE__*/ _jsx(Stack, {
                horizontal: true,
                className: contentStyles.loader,
                children: /*#__PURE__*/ _jsx(Spinner, {
                    size: SpinnerSize.large
                })
            }),
            (comments === null || comments === void 0 ? void 0 : comments.newlyAddedComments) ? mapNewlyAddedCommentsToComponents(comments.newlyAddedComments) : null
        ]
    });
}
